import useDeleteApi from '../api/useDeleteApi'

function useDelete (api) {
  return useDeleteApi(api)
}

export default useDelete
